import DodoneInnerIgnoreButton from 'app/dodones/shared/InnerIgnoreButton'
import DodoneInnerPendifyButton from 'app/dodones/shared/InnerPendifyButton'

export default ({ onNav, ignoreDodone, pendifyDodone, ...dodoneContext }) => {
  const dodone = dodoneContext.dodone

  const onIgnoreDodone = useCallback(() => {
    ignoreDodone()
    if (onNav) onNav()
  }, [ignoreDodone, dodone, onNav])

  const onPendifyDodone = useCallback(() => {
    pendifyDodone()
    if (onNav) onNav()
  }, [pendifyDodone, dodone, onNav])

  const isDayDodone = dodone.dodoable.typeViewPrefix == 'Day'
  const hideIgnoreButton = dodone.isIgnored || isDayDodone

  return (
    <>
      <Link
        className="text-lg"
        to={`/dodoables/${dodone.dodoable_id}`}
        onClick={onNav}
      >
        {dodone.dodoable.name} Log
      </Link>
      <DodoneInnerIgnoreButton
        {...dodoneContext}
        ignoreDodone={onIgnoreDodone}
      />
      <DodoneInnerPendifyButton
        {...dodoneContext}
        pendifyDodone={onPendifyDodone}
      />
    </>
  )
}
